import { BrowserRouter, Routes, Route } from "react-router-dom";
import MainLayout from "../components/MainLayout/MainLayout";
import ProtectedRoute from "./ProtectedRoute";
import Login from "../pages/Login/Login";
import ForgotPassword from "../pages/ForgotPassword/ForgotPassword";
import ResetPassword from "../pages/ResetPassword/ResetPassword";
//Common Form
import CommonForm from "../pages/CommonForm/CommonForm";
import Assessment from "../pages/Assessment/Assessment";
import Grades from "../pages/Grades/Grades";
import Modules from "../pages/Modules/Modules";
import Questions from "../pages/Questions/Questions";
import Students from "../pages/Students/Students";
import StudentAssessmentResult from "../pages/Students/StudentAssessmentResult";
import ManageTeam from "../pages/ManageTeam/ManageTeam";
import AddEditStaff from "../pages/ManageTeam/AddEditStaff";
import ManageBranch from "../pages/ManageBranch/ManageBranch";
import AddEditBranch from "../pages/ManageBranch/AddEditBranch";
import Settings from "../pages/Settings/Settings";
import Dashboard from "../pages/Dashboard/Dashboard";

const AppRoutes = () => (
  <Routes>
    <Route
      element={
        // <ProtectedRoute>
        <MainLayout />
        // </ProtectedRoute>
      }
    >
      <Route path="/assessment" element={<Assessment />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/grades/:id" element={<Grades />} />
      <Route path="/modules/:id/:gradeId" element={<Modules />} />
      <Route path="/questions/:id/:gradeId" element={<Questions />} />
      <Route path="/questions/:id/:gradeId/:moduleId" element={<Questions />} />
      <Route path="/students/:id/:gradeId" element={<Students />} />
      <Route path="/student-assessment-result/:studentId" element={<StudentAssessmentResult />} />

      <Route path="/manage-team" element={<ManageTeam />} />
      <Route path="/add-staff" element={<AddEditStaff />} />
      <Route path="/edit-staff/:teamId" element={<AddEditStaff />} />

      <Route path="/manage-branch" element={<ManageBranch />} />
      <Route path="/add-branch" element={<AddEditBranch />} />
      <Route path="/edit-branch/:branchId" element={<AddEditBranch />} />

      {/* Common Form */}
      <Route path="/common-form/:typeId" element={<CommonForm />} />
      <Route path="/common-form" element={<CommonForm />} />
      <Route path="/settings" element={<Settings />} />

    </Route>
  </Routes>
);

const RouterComponent = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/*" element={<AppRoutes />} />
      </Routes>
    </BrowserRouter>
  );
};

export default RouterComponent;
